import React from 'react';
import './Footer.css';
import riIcon from './response_ri_icon.png';

function Footer() {
  return (
    <footer className="main-footer">
      <div className="footer-inner">
        <p className="footer-left">
          2026 &copy; <strong className="footer-brand-highlight">eTour</strong>. All rights reserved.
        </p>
        <div className="footer-right">
          <span className="footer-credit-label">Design &amp; Develop by</span>
          <a
            href="https://responseinfoway.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-brand-link"
            title="Response Infoway - Applying Technology"
          >
            <img src={riIcon} alt="Response Infoway" className="footer-ri-icon" />
            <span className="footer-brand-name">Response Infoway</span>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
